import * as React from 'react';
import { preparePhrase } from "../../cardHelpers";

export default function Example(props: { example: string, phrase: string, language: string | undefined }) {

    let { example, phrase, language } = props;
    phrase = preparePhrase(phrase, language);

    const regex = new RegExp(phrase, "i");
    const match = example.match(regex);

    if (match) {
        const start = match.index;
        const end = start! + match[0].length;

        return <span style={{ whiteSpace: 'pre-wrap' }}>
            {start !== 0 &&
                <span>{example.substring(0, start)}</span>}

            <span className='example-hl'>{example.substring(start!, end)}</span>

            {end !== example.length &&
                <span>{example.substring(end, example.length)}</span>}
        </span>
    }
    return <span style={{ whiteSpace: 'pre-wrap' }}>{example}</span>
}
